/**
 * Copies a VdoSetTopicInput and settles its `vdoLength` field.
 *
 * The edit forms seed that field from the topic row they were handed, and a
 * row that came back from a document with a narrower selection set has no
 * vdoLength at all. `parseInt(undefined)` and `parseInt('')` are both NaN,
 * JSON.stringify turns NaN into null, and VdoSetTopic.vdoLength is a required
 * Int -- so the old `vdoLength: parseInt(value)` sent null and Prisma rejected
 * the entire update:
 *
 *   Invalid `prisma.vdoSetTopic.update()` invocation:
 *     data: { vdoLength: null }
 *
 * Removing the key instead leaves the stored length untouched, which is what
 * "save the topic without touching its video" should mean. On the add path the
 * column's own default (0) applies -- the same value addVdoSetTopic used to
 * coerce the null to.
 *
 * The key is deleted rather than set to undefined: `{vdoLength: undefined}` is
 * still a key, and while JSON.stringify happens to drop it, that is a property
 * of the transport rather than something this decision should rest on.
 *
 * @param {object} input the form's vdoSetTopicInput; not mutated
 * @param {*} value seconds, as a number or a string from a form field
 * @return {object} a copy carrying an integer vdoLength, or no vdoLength key
 */
export function withVdoLength(input, value) {
  const next = Object.assign({}, input);
  const seconds = parseInt(value, 10);

  if (isNaN(seconds)) {
    delete next.vdoLength;
  } else {
    next.vdoLength = seconds;
  }

  return next;
}
